import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const stats = [
  { value: 98, suffix: "%", label: "growth for a tech comparison platform" },
  { value: 300, suffix: "%", label: "SEO growth for a finance & accounting leader" },
  { value: 125, suffix: "%", label: "scaling a TMT & steel brand" },
  { value: 22, suffix: "", label: "enterprise deals from 3,500 clicks" },
];

function CountUp({ to, duration = 1600 }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setVal(Math.round(eased * to));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return <span ref={ref}>{val}</span>;
}

export default function ImpactStats() {
  return (
    <section
      data-testid="impact-stats"
      className="section-dark py-section relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30">
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[radial-gradient(circle,rgba(255,176,0,0.3),transparent_60%)] blur-3xl" />
      </div>
      <div className="grain-overlay" />
      <div className="container-xl relative">
        <div className="max-w-4xl mb-16 md:mb-24 text-center mx-auto">
          <div className="text-[11px] uppercase tracking-[0.22em] text-white/50 mb-5">
            The numbers
          </div>
          <h2 className="font-display text-white text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.02] font-semibold">
            Pipeline impact,{" "}
            <span className="font-serif italic font-light gradient-text-vivid">
              measured in outcomes.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12 md:gap-x-12 lg:gap-x-14">
          {stats.map((s, i) => {
          const colors = ["#FFB000", "#3BA7D1", "#E96A7F", "#0FB5A6"];
          const color = colors[i % colors.length];
          return (
            <div
              key={i}
              data-testid={`impact-stat-${i}`}
              className="relative border-t border-white/15 pt-8 md:pt-10"
            >
              <span
                className="absolute left-0 top-0 h-0.5 w-20"
                style={{ background: color }}
              />
              <div
                className="font-display text-white font-semibold tracking-tighter leading-[0.92]"
                style={{
                  fontSize: "clamp(56px, 6vw, 96px)",
                  letterSpacing: "-0.045em",
                }}
              >
                <CountUp to={s.value} />
                <span style={{ color }}>{s.suffix}</span>
              </div>
              <div className="mt-6 text-white/60 text-sm md:text-base leading-relaxed max-w-[280px]">
                {s.label}
              </div>
            </div>
          );
        })}
        </div>
      </div>
    </section>
  );
}
